import { render, staticRenderFns } from "./LixiaControl.vue?vue&type=template&id=026105da&scoped=true&"
import script from "./LixiaControl.vue?vue&type=script&lang=ts&"
export * from "./LixiaControl.vue?vue&type=script&lang=ts&"
import style0 from "./LixiaControl.vue?vue&type=style&index=0&id=026105da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026105da",
  null
  
)

export default component.exports